// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import lightning01Icon from "@/assets/icons/lightning-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Lightning01IconProps = Omit<IconProps, "name">;

export function Lightning01Icon(props: Lightning01IconProps): React.ReactNode {
  return <Icon name={lightning01Icon} {...props} />;
}
